// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Compromissos_CriarCompromissoWizardResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /compromissos/criar_compromisso_wizard
 *
 * Returns the ID of the created compromisso.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Compromissos_CriarCompromissoWizardResponseDados {
compromisso_id: number
}

export type Compromissos_CriarCompromissoWizardResponse = ApiResponse<Compromissos_CriarCompromissoWizardResponseDados>;

registerResponseContract('Compromissos_CriarCompromissoWizardResponse', {
  compromisso_id: { type: 'number',  required: true },
})
